// extracted by mini-css-extract-plugin
export default {"selected":"TagItem_selected__zrpfO","navButton":"TagItem_navButton__yyZDn","delete":"TagItem_delete__cy3dr","edit":"TagItem_edit__s+Xvs","input":"TagItem_input__nbzAe"};